import React, { Component } from 'react';
import { generate } from 'shortid';
import FieldGroup from './FieldGroup';
import { EmailValidation } from '../../tools/Validations';

class EmailField extends Component {
  constructor(props) {
    super(props);
    let {
      value,
      validation = new EmailValidation(),
    } = props;
    this.id = generate();
    this.validation = validation;
    this.validation.test(value);
  }

  render() {
    let {
      value,
      onChange,
      ...otherProps,
    } = this.props;

    return (
      <FieldGroup
        id={this.id}
        name="email"
        type="email"
        label="E-mail"
        value={value}
        onChange={this.onChange}
        onBlur={this.validate}
        validation={this.validation}
        placeholder="bob@example.com"
        {...otherProps} />
    );
  }

  onChange = (e) => {
    let isValid = this.validation.test(e.target.value);
    let onChange = this.props.onChange;
    if (onChange) {
      onChange(e, isValid);
    }
  }
}

export default EmailField;



// WEBPACK FOOTER //
// ./src/components/FieldGroup/EmailField.js